// TierStatus.tsx ─ your VIP use-case
import { Box, Typography, useTheme } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import Stepper, { Step } from './Stepper'
import { getTierStatus, TierStatusList } from '../api/getTierStatus'
import { subtitleShadow } from '../utils/styles'

export const iconMap: Record<string, string> = {
  cooper: require('../assets/vip/cooper.png'),
  bronze: require('../assets/vip/bronze.png'),
  silver: require('../assets/vip/silver.png'),
  gold: require('../assets/vip/gold.png'),
  crystal: require('../assets/vip/crystal.png'),
  platinum: require('../assets/vip/platinum.png'),
  diamond: require('../assets/vip/diamond.png'),
  elite: require('../assets/vip/elite.png'),
  master: require('../assets/vip/master.png'),
}

interface TierStatusProps {
  now: string
}

const TierStatus = ({ now }: TierStatusProps) => {
  const { data = [] } = useQuery<TierStatusList[]>({
    queryKey: ['getTierStatus'],
    queryFn: getTierStatus,
    staleTime: Infinity,
  })
  const theme = useTheme()

  const steps: Step[] = data
    .filter((t) => iconMap[t.name.toLowerCase()])
    .map((t) => ({
      key: t.name.toLowerCase(),
      icon: iconMap[t.name.toLowerCase()],
      label: t.name.toUpperCase(),
    }))

  return (
    <Box
      sx={{
        width: '-webkit-fill-available',
        pl: { xs: 2, md: 0 },
        pr: { xs: 4, md: 0 },
      }}
    >
      <Typography
        variant="h6"
        fontWeight="900"
        sx={{
          color: 'secondary.main',
          mb: 2,
          display: { xs: ' none', md: 'flex' },
          textTransform: 'uppercase',
          fontSize: '1.6rem',
          ...subtitleShadow,
        }}
      >
        current status
      </Typography>

      <Stepper
        steps={steps}
        current={now.toLowerCase()}
        barColor={theme.palette.primary.main}
        renderBelow={(s) => (
          <>
            <Box component="img" src={s.icon} alt={s.key} sx={{ width: 60, mt: 4 }} />
            <Typography
              variant="caption"
              fontWeight="bold"
              sx={{ color: 'secondary.main', mt: 1, display: 'block' }}
            >
              {s.label}
            </Typography>
          </>
        )}
      />
    </Box>
  )
}

export default TierStatus
